
export const capitalize = (string = "") => {
	if (!string) return "";
	return string?.charAt(0)?.toUpperCase() + string?.slice(1);
};

export const scrollToTop = () => {
	window.scrollTo({
		top: 0,
		behavior: "smooth", // smooth scrolling
	});
};
// Convert a GMT/UTC date string from backend to user's local timezone
// Returns formatted date string like "2025-03-16" (YYYY-MM-DD) in user's local timezone
export const formatDateToLocal = (dateString) => {
	if (!dateString) return "N/A";
	try {
		// Backend sends dates in GMT - ensure we parse as UTC
		// Handle formats like "2025-03-16T10:30:00.000+0000" or "2025-03-16T10:30:00"
		let utcDateStr = dateString;
		// If the string has no timezone indicator, treat it as UTC
		if (!dateString.endsWith("Z") && !dateString.includes("+") && !/\d{2}:\d{2}$/.test(dateString.slice(-5))) {
			utcDateStr = dateString + "Z";
		}
		const date = new Date(utcDateStr);
		if (isNaN(date.getTime())) return "Invalid date";
		// Format in user's local timezone as YYYY-MM-DD
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, "0");
		const day = String(date.getDate()).padStart(2, "0");
		return `${year}-${month}-${day}`;
	} catch (e) {
		return "Invalid date";
	}
};

// utils/timeAgo.js
export const formatTimeAgo = (dateString) => {
	const date = new Date(dateString);
	const now = new Date();
	const seconds = Math.floor((now - date) / 1000);

	let interval = Math.floor(seconds / 31536000);
	if (interval >= 1) return interval === 1 ? "1 year ago" : `${interval} years ago`;

	interval = Math.floor(seconds / 2592000);
	if (interval >= 1) return interval === 1 ? "1 month ago" : `${interval} months ago`;

	interval = Math.floor(seconds / 86400);
	if (interval >= 1) return interval === 1 ? "1 day ago" : `${interval} days ago`;

	interval = Math.floor(seconds / 3600);
	if (interval >= 1) return interval === 1 ? "1 hour ago" : `${interval} hours ago`;

	interval = Math.floor(seconds / 60);
	if (interval >= 1) return interval === 1 ? "1 minute ago" : `${interval} minutes ago`;

	return "just now";
};
